import React from "react";
import { Box, Button, List, ListItem, ListItemText, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AttachFileIcon from "@material-ui/icons/AttachFile";

interface PbhWaitingResponseFileUploaderProps {
  tempFiles: any[];
  setTempFiles: React.Dispatch<React.SetStateAction<any[]>>;
  disabled?: boolean;
}

const PbhWaitingResponseFileUploader: React.FC<PbhWaitingResponseFileUploaderProps> = ({
  tempFiles,
  setTempFiles,
  disabled = false,
}) => {
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const newFiles = Array.from(files).map(file => ({
        name: file.name,
        size: file.size,
        type: file.type,
        file: file,
      }));
      setTempFiles((prev: any[]) => [...prev, ...newFiles]);
    }
    // Reset input value to allow selecting same file again
    event.target.value = "";
  };

  const removeTempFile = (index: number) => {
    setTempFiles((prev: any[]) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box>
      <Button
        variant="outlined"
        component="label"
        startIcon={<AttachFileIcon />}
        disabled={disabled}
        size="small"
      >
        Select File
        <input type="file" hidden onChange={handleFileSelect} multiple={false} accept=".pdf,.xlsx,.xls,.doc,.docx" />
      </Button>

      {tempFiles.length > 0 && (
        <Box mt={1}>
          <List dense>
            {tempFiles.map((file: any, index: number) => (
              <ListItem key={index} dense>
                <ListItemText
                  primary={file.name}
                  secondary={file.size ? `${(file.size / 1024).toFixed(1)} KB` : ""}
                />
                <IconButton edge="end" aria-label="delete" size="small" onClick={() => removeTempFile(index)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default PbhWaitingResponseFileUploader;